import styled from "styled-components";

let titleBarHeight = 100;

export const TractorDetailsScreenWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-position: center;
    background-size: cover;
`;

export const TractorDetailsScreenInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-color: rgba(0, 0, 0, 0.85);
    background-image: url("/static/images/big-screen/tractor/details-screen-background.png");
    background-size: 100% 100%;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 100;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight}px;
    padding: 40px 10px 10px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const DeviceDetailsContent = styled.div`
    display: grid;
    position: absolute;
    top: calc(${titleBarHeight}px);
    width: 100%;
    height: calc(100% - ${titleBarHeight}px);
    padding: 10px 60px 60px 60px;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: repeat(3, minmax(0, 1fr));
    grid-gap: 20px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    overflow: hidden;
`;

export const DeviceModel3DWrapper = styled.div`
    grid-column: 2 / span 2;
    grid-row: 1 / span 2;
`;

export const MotorCardWrapper = styled.div`
    grid-column: span 1;
    grid-row: span 1;
    background-image: url("/static/images/big-screen/tractor/motor-border-card.png");
    background-size: 100% 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    clip-path: polygon(30px 0, calc(100% - 30px) 0, 100% 30px, 100% calc(100% - 30px), calc(100% - 30px) 100%, 30px 100%, 0 calc(100% - 30px), 0 30px);
`;

export const MotorCardHeader = styled.div`
    height: 20px;
    text-align: center;
    font-size: 16px;
    padding: 5px 10px;
`;

export const ChartsWrapper = styled.div`
    display: grid;
    width: 100%;
    height: 130px;
    padding: 5px 20px;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(1, minmax(0, 1fr));
    box-sizing: border-box;
`;

export const ChartWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const ChartHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
`;

export const ChartName = styled.div`
    text-align: center;
`;

export const RealtimeDeviceMetricsWrapper = styled.div`
    display: grid;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 1px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-rows: 50px;
    box-sizing: border-box;
    padding: 5px 20px;
`;

export const RealtimeDeviceMetricItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`;

export const RealtimeDeviceMetricItemLabel = styled.div`
    font-size: 14px;
`;

export const RealtimeDeviceMetricItemValue = styled.div`
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: rgba(204, 243, 247, 1.0);
`;

export const RealtimeDeviceMetricsUnit = styled.div`
    margin-left: 5px;
    display: inline;
    font-size: 9px;
    color: #FFFFFF;
`;

export const EChartsWrapper = styled.div`
    flex: 1 1 auto;
`;

